// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FoundSubEntitiesTable__table___Fup1H {
    overflow-x: hidden;
    border: var(--control-border-width) solid var(--color-bg-border);
}

.FoundSubEntitiesTable__titleCell___mBIMZ {
    text-transform: capitalize;
}

.FoundSubEntitiesTable__iconCell___RcUMs {
    display: flex;
    align-items: center;
    padding-top: 0.3rem;
}

.FoundSubEntitiesTable__iconWrapper___UxiPk {
    display: flex;
    align-items: center;
    padding-right: 0.4rem;
    padding-left: 0.4rem;
}

.FoundSubEntitiesTable__tableCell___G2FhU {
    padding-top: 0.3rem;
}

.FoundSubEntitiesTable__columns3___Ta6UQ {
    grid-template-columns: 1fr 1fr 1fr;
}

.FoundSubEntitiesTable__columns4___vQS_e {
    grid-template-columns: 1fr 1fr 1fr 1fr;
}

.FoundSubEntitiesTable__tableAddButton___xU7Gv {
    visibility: hidden;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.FoundSubEntitiesTable__table___Fup1H .Table-CellsRow:hover .FoundSubEntitiesTable__tableAddButton___xU7Gv {
    visibility: initial;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/OverallImport/NewImportResults/SearchResultsContent/FoundSubEntitiesTable.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gEAAgE;AACpE;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;AACtB;;AAEA,uEAAuE;AACvE;IACI,mBAAmB;AACvB","sourcesContent":[".table {\n    overflow-x: hidden;\n    border: var(--control-border-width) solid var(--color-bg-border);\n}\n\n.titleCell {\n    text-transform: capitalize;\n}\n\n.iconCell {\n    display: flex;\n    align-items: center;\n    padding-top: 0.3rem;\n}\n\n.iconWrapper {\n    display: flex;\n    align-items: center;\n    padding-right: 0.4rem;\n    padding-left: 0.4rem;\n}\n\n.tableCell {\n    padding-top: 0.3rem;\n}\n\n.columns3 {\n    grid-template-columns: 1fr 1fr 1fr;\n}\n\n.columns4 {\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n}\n\n.tableAddButton {\n    visibility: hidden;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.table :global(.Table-CellsRow):hover .tableAddButton {\n    visibility: initial;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `FoundSubEntitiesTable__table___Fup1H`,
	"titleCell": `FoundSubEntitiesTable__titleCell___mBIMZ`,
	"iconCell": `FoundSubEntitiesTable__iconCell___RcUMs`,
	"iconWrapper": `FoundSubEntitiesTable__iconWrapper___UxiPk`,
	"tableCell": `FoundSubEntitiesTable__tableCell___G2FhU`,
	"columns3": `FoundSubEntitiesTable__columns3___Ta6UQ`,
	"columns4": `FoundSubEntitiesTable__columns4___vQS_e`,
	"tableAddButton": `FoundSubEntitiesTable__tableAddButton___xU7Gv`
};
export default ___CSS_LOADER_EXPORT___;
